import { render } from "./Widget3.vue?vue&type=template&id=79ea4f01"
import script from "./Widget3.vue?vue&type=script&lang=ts"
export * from "./Widget3.vue?vue&type=script&lang=ts"
script.render = render

export default script